import { render, staticRenderFns } from "./noticeProclamation.vue?vue&type=template&id=6eacf210&scoped=true&"
import script from "./noticeProclamation.vue?vue&type=script&lang=ts&"
export * from "./noticeProclamation.vue?vue&type=script&lang=ts&"
import style0 from "./noticeProclamation.vue?vue&type=style&index=0&id=6eacf210&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6eacf210",
  null
  
)

export default component.exports